import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=55f43f36&scoped=true&"
import script from "./Separator.vue?vue&type=script&lang=js&"
export * from "./Separator.vue?vue&type=script&lang=js&"
import style0 from "./Separator.vue?vue&type=style&index=0&id=55f43f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f43f36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f43f36')) {
      api.createRecord('55f43f36', component.options)
    } else {
      api.reload('55f43f36', component.options)
    }
    module.hot.accept("./Separator.vue?vue&type=template&id=55f43f36&scoped=true&", function () {
      api.rerender('55f43f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Separator.vue"
export default component.exports